import { render, staticRenderFns } from "./BaseDropZone.vue?vue&type=template&id=7686a018&"
import script from "./BaseDropZone.vue?vue&type=script&lang=js&"
export * from "./BaseDropZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports